export class UnknownErrorAndWeCouldNot extends Error {
  static getErrorMessage(weCouldNotAction: string) {
    return `Oops something went wrong and we couldn't ${weCouldNotAction}.`;
  }

  constructor(weCouldNotAction: string) {
    super(UnknownErrorAndWeCouldNot.getErrorMessage(weCouldNotAction));
  }
}
